import { render } from "./ComponenteRoCogeneracion.vue?vue&type=template&id=b820ab90&scoped=true"
import script from "./ComponenteRoCogeneracion.vue?vue&type=script&lang=js"
export * from "./ComponenteRoCogeneracion.vue?vue&type=script&lang=js"

import "./ComponenteRoCogeneracion.vue?vue&type=style&index=0&id=b820ab90&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b820ab90"]])

export default __exports__